import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { createFeedMappingTab } from "./tabs/feed-mapping";
import { createLiveTab } from "./tabs/live";
import { createMainTab } from "./tabs/main";
import { createPrematchTab } from "./tabs/prematch";
import { createTranslationsTab } from "./tabs/translations";

export function createEditDialog(options: {
  ctx: BackofficeContext;
  outcomesApi: OutcomesApi;
  marketsApi: MarketsApi;
}): DialogConfig {
  const { ctx, outcomesApi, marketsApi } = options;

  return {
    id: "edit-outcome",
    title: "Edit outcome",
    layout: { type: "popover" },
    api: {
      initialValues: async (row) => {
        const data = readApiData(await outcomesApi.getSingle(row.id));
        return (data && typeof data === "object" && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >;
      },
      submit: async () => {},
    },
    structure: {
      type: "tabbed",
      savePerTab: true,
      tabs: [
        createMainTab(outcomesApi, marketsApi),
        createPrematchTab(outcomesApi),
        createLiveTab(outcomesApi),
        createTranslationsTab({ ctx, outcomesApi }),
        createFeedMappingTab(outcomesApi),
      ],
    },
  };
}
